'use client'

import { type ReactNode, useState } from 'react'
import { motion } from 'motion/react'
import { Icon } from '@/icons/Icon'
import { easeMedium } from '@/lib/transitions'

// Client island: owns the expand/collapse state + animation. The criteria content
// is server-rendered and passed in as children, so it stays out of the client bundle.
export default function EvaluationToggle({ children }: { children: ReactNode }) {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <>
      <EvaluationCTA isExpanded={isExpanded} onClickAction={() => setIsExpanded(!isExpanded)} />

      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: isExpanded ? 'auto' : 0, opacity: isExpanded ? 1 : 0 }}
        transition={easeMedium}
        className="overflow-hidden"
      >
        {children}
      </motion.div>
    </>
  )
}

function EvaluationCTA({
  isExpanded,
  onClickAction,
}: {
  isExpanded: boolean
  onClickAction: () => void
}) {
  return (
    <button
      type="button"
      onClick={onClickAction}
      aria-expanded={isExpanded}
      className="mx-auto my-5 flex w-fit cursor-pointer flex-col items-center gap-4 rounded border border-white/15 px-4 py-5 transition-colors hover:bg-white/10 sm:flex-row sm:py-2 md:my-12"
    >
      <Icon name="hexagon-check" className="text-success-500" />
      <p className="text-balance text-center text-14 text-white/60 sm:text-left [&>span]:text-white">
        Efficient App ensures <span>transparency</span> in our rankings and{' '}
        <span>evaluation methodology</span>.
      </p>
      <Icon
        name="chevron-left"
        size={12}
        className={`text-white transition-transform ${isExpanded ? 'rotate-90' : '-rotate-90'}`}
      />
    </button>
  )
}
